export default __webpack_public_path__ + "static/media/javascript.661eb771.svg";